/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HighRiskServiceGetResponse,
  HighRiskServiceRaiseResponse,
  HighRiskServiceRemoveResponse,
  HighRiskServiceReviewResponse,
} from '../models/index';
import {
    HighRiskServiceGetResponseFromJSON,
    HighRiskServiceGetResponseToJSON,
    HighRiskServiceRaiseResponseFromJSON,
    HighRiskServiceRaiseResponseToJSON,
    HighRiskServiceRemoveResponseFromJSON,
    HighRiskServiceRemoveResponseToJSON,
    HighRiskServiceReviewResponseFromJSON,
    HighRiskServiceReviewResponseToJSON,
} from '../models/index';

export interface HighRiskApiApiHighRiskGetGetRequest {
    policyNumber?: string;
}

export interface HighRiskApiApiHighRiskRaisePostRequest {
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

export interface HighRiskApiApiHighRiskRemovePostRequest {
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

export interface HighRiskApiApiHighRiskReviewPostRequest {
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

/**
 * 
 */
export class HighRiskApi extends runtime.BaseAPI {

    /**
     */
    async apiHighRiskGetGetRaw(requestParameters: HighRiskApiApiHighRiskGetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HighRiskServiceGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/HighRisk/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HighRiskServiceGetResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiHighRiskGetGet(requestParameters: HighRiskApiApiHighRiskGetGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HighRiskServiceGetResponse> {
        const response = await this.apiHighRiskGetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHighRiskRaisePostRaw(requestParameters: HighRiskApiApiHighRiskRaisePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HighRiskServiceRaiseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/HighRisk/Raise`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HighRiskServiceRaiseResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiHighRiskRaisePost(requestParameters: HighRiskApiApiHighRiskRaisePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HighRiskServiceRaiseResponse> {
        const response = await this.apiHighRiskRaisePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHighRiskRemovePostRaw(requestParameters: HighRiskApiApiHighRiskRemovePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HighRiskServiceRemoveResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/HighRisk/Remove`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HighRiskServiceRemoveResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiHighRiskRemovePost(requestParameters: HighRiskApiApiHighRiskRemovePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HighRiskServiceRemoveResponse> {
        const response = await this.apiHighRiskRemovePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHighRiskReviewPostRaw(requestParameters: HighRiskApiApiHighRiskReviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HighRiskServiceReviewResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/HighRisk/Review`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HighRiskServiceReviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiHighRiskReviewPost(requestParameters: HighRiskApiApiHighRiskReviewPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HighRiskServiceReviewResponse> {
        const response = await this.apiHighRiskReviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
